export default "__VITE_ASSET__BPj1A_ig__"